import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import { IDesignerProfile } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';

import styles from './About.module.scss';

interface IAboutProps {
  designer: IDesignerProfile;
}

const About = ({ designer } : IAboutProps) => {
  const { designAesthetic } = designer;
  const theme = useTheme();

  return (
    <div className={classNames(
      styles.Container,
      theme.styles.Body
    ) }
    >
      <div className={ styles.Row }>
        <div>
          <Label>About Me</Label>
          <p>{ designAesthetic }</p>
        </div>
      </div>
    </div>
  );
};

function Label({ children }: {children: string}) {
  const theme = useTheme();
  return (
    <p
      className={classNames(
        theme.styles.Title2,
        styles.Label
      )}
    >
      {children}
    </p>
  );
}

export default About;
